// 1. React
import { forwardRef, memo, useImperativeHandle, useRef } from "react";

// 2. Helpers
import { useTranslate } from "helpers";
import { useOpenOnTab } from "services/hooks/useOpenOnTab";

// 3. Types
import { VehicleOfferCardProps, VehicleOfferRef } from "./types";

// 4. UI Components
import { Tabs } from "ui/components/Tabs";

// 5. Local Components
import VehicleOfferSaleCard from "./components/VehicleOfferSaleCard/VehicleOfferSaleCard";
import { VehicleOfferSaleRef } from "./components/VehicleOfferSaleCard/types";
import VehicleOfferRentCard from "./components/VehicleOfferRentCard/VehicleOfferRentCard";
import { VehicleOfferRentRef } from "./components/VehicleOfferRentCard/types";
import VehicleOfferStatsCard from "./components/VehicleOfferStatsCard/VehicleOfferStatsCard";

const VehicleOfferCard = forwardRef<VehicleOfferRef, VehicleOfferCardProps>((props, ref) => {
  const { fleetVehicleDetail, onContractCreated, onInvoiceCreated } = props;

  const { t } = useTranslate();
  const vehicleOfferSaleRef = useRef<VehicleOfferSaleRef>(null);
  const vehicleOfferRentRef = useRef<VehicleOfferRentRef>(null);

  const { activeTab, setActiveTab, openOnTab } = useOpenOnTab();

  useImperativeHandle(ref, () => ({
    openAddNewSale: () => openOnTab(0, () => vehicleOfferSaleRef.current?.openAddNew()),
    openAddNewRent: () => openOnTab(1, () => vehicleOfferRentRef.current?.openAddNew()),
  }));

  if (!fleetVehicleDetail.id) return <></>;

  return (
    <>
      <Tabs
        activeIndex={activeTab}
        onTabChange={setActiveTab}
        tabs={[
          {
            label: t("admin.fleet.vehicle.offer.tab.sale"),
            content: (
              <div>
                <VehicleOfferSaleCard ref={vehicleOfferSaleRef} fleetVehicleDetail={fleetVehicleDetail} onContractCreated={onContractCreated} onInvoiceCreated={onInvoiceCreated} />
              </div>
            ),
          },
          {
            label: t("admin.fleet.vehicle.offer.tab.rent"),
            content: (
              <div>
                <VehicleOfferRentCard ref={vehicleOfferRentRef} fleetVehicleDetail={fleetVehicleDetail} onContractCreated={onContractCreated} onInvoiceCreated={onInvoiceCreated} />
              </div>
            ),
          },
          {
            label: t("admin.fleet.vehicle.offer.tab.stats"),
            content: (
              <div>
                <VehicleOfferStatsCard fleetVehicleDetail={fleetVehicleDetail} />
              </div>
            ),
          },
        ]}
      />
    </>
  );
});

export default memo(VehicleOfferCard);